<template>
    <div class="mt-6">
        <v-card>
            <a :name="command.name"></a>
            <v-toolbar flat color="primary" dark>
                <v-toolbar-title class="text-capitalize">{{ name }}</v-toolbar-title>
            </v-toolbar>
            <div class="black darken-4 d-flex flex-row">
                <div class="pa-3 method white--text">
                    {{ command.method }}
                </div>
                <div class="pa-3 uri yellow--text">
                    https://open.lnwshop.com/{shop_id}/api/v1/{{group}}/{{uri_name}}
                </div>
            </div>
            <v-tabs vertical>
                <v-tab>
                    Params
                </v-tab>
                <v-tab-item>
                    <v-card flat>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th class="text-left">Name</th>
                                    <th class="text-left">Type</th>
                                    <th class="text-left">Description</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="param in parameters" :key="param.key">
                                    <td>
                                        <span class="body-1 mono name">{{ param.key }}</span>

                                        <div class="body-2 mt-1 mb-3">
                                            <div v-if="param.required">
                                                <b>(required)</b></div>
                                            <div v-else>
                                                <i class="grey--text">(Optional)</i></div>
                                        </div>
                                    </td>
                                    <td>
                                        {{ param.type }}

                                        <div v-if="param.sample" class=" mt-1 mb-3">
                                            <div class="text-capitalize overline text--secondary text--darken-3">sample</div>
                                            <div class="caption">
                                                {{param.sample}}
                                            </div>
                                        </div>
                                    </td>
                                    <td>

                                        <v-flex v-for="(val,key) in param._others" :key="key" class="xs12 mt-1">
                                            <div class="text-capitalize overline text--secondary text--darken-3">{{key}}</div>
                                            <span class="mono">{{val}}</span>
                                        </v-flex>

                                        <div class="v-markdown" v-if="param.description">{{ param.description }}</div>
                                    </td>
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <v-data-iterator
                            v-if="false"
                            :items="parameters"
                            hide-default-footer
                        >
                            <template v-slot:default="props">
                                <div :key="item.key"
                                     class="layout api-item pa-2 wrap"
                                     v-for="item in props.items">

                                    <v-flex class="md3 xs6">
                                        <div class="text-capitalize overline text--secondary text--darken-3">name</div>
                                        <span class="mono name">{{ item.key }}</span>
                                    </v-flex>

                                    <v-flex class="xs6 md2 text-xs-right">
                                        <div class="text-capitalize overline text--secondary text--darken-3">type</div>
                                        <span class="mono">{{ item.type }}</span>
                                    </v-flex>

                                    <v-flex class="xs12 md7 text-md-right">
                                        <div class="text-capitalize overline text--secondary text--darken-3">required</div>
                                        <span class="mono">{{ item.required ? 'yes' : 'no' }}</span>
                                    </v-flex>
                                    <!--
                                    <v-flex class="xs12 md7 text-md-right">
                                        <div class="text-capitalize overline text&#45;&#45;secondary text&#45;&#45;darken-3">default</div>
                                        <span class="mono">{{ item.default }}</span>
                                    </v-flex>
                                    -->

                                    <v-flex v-for="(val,key) in item._others" :key="key" class="xs6 md3 mt-5">
                                            <div class="text-capitalize overline text--secondary text--darken-3">{{key}}</div>
                                            <span class="mono">{{val}}</span>
                                    </v-flex>

                                    <v-flex class="xs12 mt-2 mt-5" v-if="item.description">
                                        <div class="text-capitalize overline text--secondary text--darken-3">description</div>
                                        <div class="v-markdown">{{ item.description }}</div>
                                    </v-flex>


                                </div>
                            </template>
                        </v-data-iterator>
                    </v-card>
                </v-tab-item>
            </v-tabs>
            <v-tabs vertical v-if="has_response_parameters">
              <v-tab>
                Response
              </v-tab>
              <v-tab-item>
                <div v-highlight><pre class="language-json"><code>{{ example_response }}</code></pre></div>
              </v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>

<script>

    function extract_parameters(parameters, type) {
        let extracted = {};
        for (let j in parameters) {
            if (parameters[j].parameters)
                extracted[parameters[j].key] = extract_parameters(parameters[j].parameters, parameters[j].type);
            else
                extracted[parameters[j].key] = parameters[j].sample;
        }

        if (type === 'array')
            return [extracted];

        return extracted;
    }

    export default {
        name: "ApiDocsCommand",
        props: {
            command: {
                type: Object,
                required: true,
            },
        },
        computed: {
            group() {
                return this.command.name.split(".")[0];
            },
            name() {
                return this.uri_name.replace(/_/g, " ");
            },
            uri_name() {
                return this.command.name.split(".")[1];
            },
            parameters() {
                let parameters = this.command.request_parameters.slice();
                for (let i in parameters) {
                    let others = {};
                    for (let key in parameters[i]) {
                        if (
                            (['key', 'required', 'type', 'description', '_others', 'parameters', 'sample'].indexOf(key) === -1)
                            && parameters[i][key] !== null
                        )
                            others[key] = parameters[i][key];
                    }
                    parameters[i]._others = others;
                }

                return parameters;
            },
            has_response_parameters() {
                return this.command.response_parameters.length > 0;
            },
            example_response() {
                let res = {};
                res.status = "success";
                for (let i in this.command.response_parameters) {
                    res[this.command.response_parameters[i].key] = extract_parameters(
                        this.command.response_parameters[i].parameters,
                        this.command.response_parameters[i].type
                    );
                }

                return res;
            },
        },
    }
</script>

<style scoped>
    .api-item:not(:last-child) {
        border-bottom: 2px solid #ddd;
    }
    .mono.name {
        color: #d63200;
    }
    .mono {
        font-weight: bold;
    }
    .method {
        font-family: monospace;
        font-weight: bold;
        letter-spacing: 1px;
    }
    .uri {
        font-family: monospace;
    }
</style>